import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#050505] border-t border-white/10 py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-6">
        {/* Legal Disclaimer */}
        <div className="bg-zinc-900/50 border border-[#F9004D]/30 rounded-xl p-6 mb-8">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <svg className="h-5 w-5 text-[#F9004D]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="flex-1">
              <p className="text-zinc-300 text-sm leading-relaxed mb-2">
                <strong className="text-white">{t('legal.platform')}</strong>
              </p>
              <p className="text-zinc-400 text-sm leading-relaxed mb-2">
                {t('legal.disclaimer')}
              </p>
              <p className="text-zinc-400 text-sm leading-relaxed">
                {t('legal.maxGroup')}
              </p>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-white font-bold mb-4" style={{ fontFamily: 'Syne, sans-serif' }}>
              GuideMatch <span className="text-[#F9004D]">Tokyo</span>
            </h3>
            <p className="text-zinc-400 text-sm">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.experiences')}</h4>
            <ul className="space-y-2 text-sm">
              <Link to="/hosts" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.localHosts')}
              </Link>
              <Link to="/become-host" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.becomeHost')}
              </Link>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2 text-sm">
              <Link to="/terms" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.terms')}
              </Link>
              <Link to="/cgv" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.cgv')}
              </Link>
              <Link to="/privacy" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="/about" className="block text-zinc-400 hover:text-white transition-colors">
                {t('footer.about')}
              </Link>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.contact')}</h4>
            <p className="text-zinc-400 text-sm">
              contact@guidematch-tokyo.com
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-zinc-500 text-sm">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};
